module.exports = __webpack_public_path__ + "static/img/230825_BB_TropicalPunch_Smiley_Anim01_1.ae3c852.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_TropicalPunch_Smiley_Anim01_1.gif
// module id = bwDP
// module chunks = 0